import React, { ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { spaces, typography } from '../../assets/styles/themes/tokens';

interface BannerBarProps {
  backgroundColor: string;
  color: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

export const BannerBar: React.FC<BannerBarProps> = ({ backgroundColor, color, children, sx }) => {
  return (
    <Box
      // Compose as an array so a consumer's `@media` block merges with the base
      // one instead of overwriting it (object spread would clobber same-key media).
      sx={[
        (theme) => ({
          backgroundColor,
          color,
          flexDirection: 'column',
          textAlign: 'center',
          // Reuse the type-scale sizes off the DS `body2`/`body1` variants. We take
          // the sizes (not the `typography` variant shorthand) because that shorthand
          // bakes in the variants' `text.secondary` color — unreadable on the banner —
          // and its responsive form doesn't resolve the custom `mobile` breakpoint.
          fontSize: typography.body2.fontSize,
          paddingTop: spaces.xs,
          paddingBottom: spaces.xs,
          paddingRight: spaces.lg,
          paddingLeft: spaces.lg,
          display: 'flex',
          [theme.breakpoints.up('mobile')]: {
            flexDirection: 'row',
            textAlign: 'left',
            fontSize: typography.body1.fontSize,
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
};

export const BannerBarMessage: React.FC = ({ children }) => {
  return (
    <Box sx={{
      flexGrow: 1,
      minWidth: 0,
      paddingTop: spaces.xs,
      paddingBottom: spaces.xs,
    }}>
      {children}
    </Box>
  );
};

export default BannerBar;
